import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import Services from './ourservices';  // Make sure this matches the file name
import reportWebVitals from './reportWebVitals';
import BookingTracker from './BookingTracker';

document.title = "Arogyabindu";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/services" element={<Services />} />
        <Route path="/BookingTracker" element={<BookingTracker />} />

      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();